import React from "react";
import {ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled, { createGlobalStyle } from "styled-components";
import { css } from "styled-components/macro";  
import Header from "components/headers/light.js";
import Footer from "components/footers/FiveColumnWithInputForm.js";
import photo4 from '../images/latest/Supervisie.JPG';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';

import wvBackground from "../images/wv_p5.svg"; // Adjust the path as necessary
const Container = tw.div`relative flex justify-center items-center`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-auto py-20 md:py-2
  m-4 md:m-8 lg:m-12`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const TextColumn = styled(Column)(props => [
    tw`md:w-7/12 mt-16 md:mt-0`,
    tw`md:mr-12 lg:mr-16 md:order-first`
]);
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 h-80 md:h-auto z-0 relative`;
const Image = styled.div`
    background-image: url(${props => props.imageSrc});
    ${tw`rounded-lg bg-contain bg-no-repeat bg-center h-full`}
 
 `;

const TextContent = tw.div`lg:py-8 text-center md:text-left`;

 
 
 
const GlobalStyle = createGlobalStyle`
  body {
    background-image: url(${wvBackground}), url(${wvBackground});
    background-size: cover, cover;
    background-repeat: no-repeat, no-repeat;
    background-position: 60%, top;
    margin: 0;
    padding: 0;
    font-family: 'Inter', system-ui, sans-serif;
  }

  body::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100vh;
    background-image: url(${wvBackground});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top;
    transform: scaleY(-1);
    z-index: -1;
  }
`;
const Text = styled.div`
${tw`text-lg text-gray-800 mx-auto px-4 sm:px-6 md:px-8 lg:px-10 xl:px-12`}
// max-width: 48rem; // adjust this value as needed
p {
  ${tw`mt-2`}
}
h1 {
  ${tw`text-2xl font-bold mt-2`}
}
h2 {
  ${tw`text-2xl font-bold mt-20`}
}
h3 {
  ${tw`text-xl font-bold mt-4`}
}
ul {
  ${tw`list-disc list-inside`}
  li {
    ${tw`ml-2 mb-3`}
    p {
      ${tw`mt-0 inline leading-normal`}
    }
  }
}
`;
export default ({ headingText = "Privacy Policy" }) => {
  return (
    <>
          <Header />

        <GlobalStyle />
        <Container>

        <TwoColumn>
          
            <TextColumn>
                <TextContent>

  <ContentWithPaddingXl>
    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
      <Text style={{ flex: 1 }}>
        <h1 style={{ fontSize: '36px' }}>Supervisie</h1>
        Voor zowel psychologen, als psychologen in opleiding tot GZ-Psycholoog, en GZ-psychologen kan ik supervisie bieden. Supervisie is een gestructureerde vorm van begeleiding waarbij ik als supervisor jou als externe professional ondersteun in de praktijk. Het doel van de supervisie is het versterken van therapeutische vaardigheden, het bevorderen van je professionele rol, en het vergroten van zelfreflectie. Dit komt aan bod door middel van het bespreken van casuïstiek.

        <br></br>
        <br></br>

        In 2013 ben ik gestart met werken als psycholoog en sinds 2022 mag ik mijzelf GZ-psycholoog noemen. In deze jaren heb ik op verschillende plekken mogen werken zoals de revalidatie, forensisch, verslaving, geriatrie, neurologie, maar ook de reguliere basis GGZ. Hier heb ik individueel behandeld, groepen gegeven, diagnostiek gedaan, en ook in de functie van zorg- en projectmanager gewerkt.

        <br></br>
        <br></br>

        <ul style={{marginTop:"1%"}}>
          <li>Supervisie (o.b.v. 45 minuten) €120</li>
        </ul>

        <br></br>

        Wil je meer weten over mijn werkervaring? 
        <br></br>
        <br></br>

        
        Kijk gerust op mijn LinkedIn
        <a href="https://www.linkedin.com/in/leanda-bosschaart/" target="_blank" rel="noopener noreferrer">
          <div style={{ 
            display: 'inline-flex', 
            backgroundColor: '#0077b5', 
            borderRadius: '50%', 
            padding: '10px', 
            color: 'white', 
            alignItems: 'center', 
            justifyContent: 'center', 
            marginLeft: '10px'
          }}>
            <FontAwesomeIcon icon={faLinkedinIn} size="1x" />
          </div>
        </a>
      </Text>
      {/* <img src= {photo4} alt="Photo" style={{ marginLeft: '20px', maxWidth: "30%", height: 'auto', borderRadius:"5%" }} /> */}
    </div>
  </ContentWithPaddingXl>

</TextContent>
            </TextColumn>
            <ImageColumn>
                <Image  imageSrc={photo4}/>
            </ImageColumn>
        </TwoColumn>
        </Container>

      <div style={{marginTop:"20%"}}></div>
      <Footer />
      </>
  );
};
